<template>
  <div class="card-user-input block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-user-input-icon white--text text-lg-2" />
            </div>
            <h4>
              User Input
              <v-icon
                v-if="errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <form-validation v-model="errorsCount" v-if="validData">
          <div class="">
            <draggable
              v-model="data.items"
              group="cards-user-input"
              handle=".handle-user-input"
              @start="drag = true"
              @end="drag = false"
            >
              <div
                v-for="(item, index) in data.items"
                class="user-input-item card-inner-wrapper"
              >
                <v-layout row wrap class="">
                  <v-flex xs12>
                    <label>Message To User</label>
                    <!--                                <v-text-field-->
                    <!--                                        outline-->
                    <!--                                        v-model="item.message"-->
                    <!--                                        :error="!item.message"-->
                    <!--                                        :error-messages="!item.message? 'Message To User is Required':'' "-->
                    <!--                                >-->
                    <!--                                </v-text-field>-->
                    <vTextareaAutocomplete
                      v-model="item.message"
                      :type="'textarea'"
                      :counter="80"
                      :validation-rules="
                        autocompleteUserInputMessageValidationRules
                      "
                    />
                  </v-flex>
                  <v-flex
                    v-if="item.validation !== 'location'"
                    :class="item.validation == 'location' ? 'xs12' : 'xs6'"
                  >
                    <label>Attribute to save in</label>
                    <v-text-field
                      v-model="item.save_to_attribute"
                      :error="!item.save_to_attribute"
                      :error-messages="
                        !item.save_to_attribute ? 'Attribute is Required' : ''
                      "
                      outline
                    />
                  </v-flex>
                  <v-flex
                    :class="item.validation == 'location' ? 'xs12' : 'xs6'"
                  >
                    <label>Validation</label>
                    <v-autocomplete
                      :items="validationList"
                      v-model="item.validation"
                      :error="!item.validation"
                      :error-messages="
                        !item.validation ? 'Validation is Required' : ''
                      "
                      item-text="name"
                      item-value="value"
                      outline
                      solo
                    />
                  </v-flex>
                  <v-flex xs12>
                    <div v-if="item.validation === 'userAttribute'">
                      <label>Select User Attribute</label>
                      <vTextareaAutocomplete
                        :items="variables"
                        :type="'textfield'"
                        v-model="item.userAttribute"
                        :error="!item.userAttribute"
                        :error-messages="
                          !item.userAttribute ? 'Attribute is Required' : ''
                        "
                        outline
                        solo
                        item-text="variable"
                        item-value="variable"
                      />
                    </div>
                    <div v-if="item.validation === 'other'">
                      <label>Regex</label>
                      <v-text-field
                        v-model="item.regex"
                        :error="!item.regex"
                        :error-messages="!item.regex ? 'Regex is Required' : ''"
                        outline
                      />
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <label>Error Message</label>
                    <!--                                <v-text-field-->
                    <!--                                        outline-->
                    <!--                                        v-model="item.errorMsg"-->
                    <!--                                        :error="!item.errorMsg"-->
                    <!--                                        :error-messages="!item.errorMsg? 'Error Message is Required':'' "-->
                    <!--                                >-->
                    <!--                                </v-text-field>-->
                    <vTextareaAutocomplete
                      v-model="item.errorMsg"
                      :type="'textfield'"
                      :validation-rules="
                        autocompleteUserErrorMessageValidationRules
                      "
                    />
                  </v-flex>

                  <v-flex xs12>
                    <label for="">Has Trials Limit</label>
                    <v-switch v-model="item.hasTrialsLimit" />
                  </v-flex>

                  <v-flex xs12>
                    <label>Trials Number </label>
                    <v-text-field
                      outline
                      type="number"
                      min="1"
                      v-model="item.numOfTrials"
                      :error="!item.numOfTrials"
                      :disabled="!item.hasTrialsLimit"
                      :error-messages="
                        !item.numOfTrials ? 'Trials Number is Required' : ''
                      "
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <label for="">Redirection Block</label>
                    <v-autocomplete
                      :items="blocksList"
                      :disabled="!item.hasTrialsLimit"
                      item-text="name"
                      item-value="id"
                      v-model="item.redirectBlock"
                      :rules="[(v) => !!v || 'Block is Required']"
                      outline
                      solo
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <div class="inner-block-actions">
                  <v-btn
                    fab
                    small
                    round
                    color=""
                    class="delete-button"
                    @click="deleteUserInput(index)"
                    ><v-icon small color="red">delete_outline</v-icon></v-btn
                  >
                  <v-btn class="handle-user-input" fab small color=""
                    ><v-icon color="#666">height</v-icon></v-btn
                  >
                </div>
              </div>
            </draggable>
            <v-layout row wrap>
              <v-flex xs12 class="">
                <div class="add-new-gallery-item">
                  <v-btn
                    large
                    round
                    flat
                    block
                    class="primary--text"
                    @click="addUserAttribute"
                  >
                    <v-icon>add_circle_outline</v-icon>
                    Add User Input
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </form-validation>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
export default {
  name: "card-user-input",
  components: {
    draggable,
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      validationList: [
        { name: "Text", value: "text" },
        { name: "Number", value: "number" },
        { name: "Email", value: "email" },
        { name: "User Attribute", value: "userAttribute" },
        { name: "File", value: "file" },
        { name: "Location", value: "location" },
        { name: "Other", value: "other" },
      ],
      autocompleteUserInputMessageValidationRules: [
        (v) => !!v || "Message to user is Required",
      ],
      autocompleteUserErrorMessageValidationRules: [
        (v) => !!v || "Error Message is Required",
      ],
    };
  },
  computed: {
    variables() {
      return this.$store.state.blocksBuild.variables;
    },
  },
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    deleteUserInput(index) {
      this.data.items.splice(index, 1);
    },
    addUserAttribute() {
      this.data.items.push({
        message: "",
        validation: "",
        save_to_attribute: "",
        userAttribute: "",
        regex: "",
        errorMsg: "",
      });
    },
  },
};
</script>

<style scoped></style>
